/* unplugin-vue-components disabled */import { render } from "./users.vue?vue&type=template&id=24728ea4"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"

import "./users.vue?vue&type=style&index=0&id=24728ea4&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/tenants/users.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24728ea4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24728ea4', __exports__)) {
    api.reload('24728ea4', __exports__)
  }
  
  module.hot.accept("./users.vue?vue&type=template&id=24728ea4", () => {
    api.rerender('24728ea4', render)
  })

}


export default __exports__